// extracted by mini-css-extract-plugin
export default {"cloture_container":"Cloture_cloture_container__1rtxy","cloture_header":"Cloture_cloture_header__9jamX","gradient_div":"Cloture_gradient_div__+n5dm"};